let counter = 0;

class User {
  constructor({
    id,
    screenName,
    fullName,
    user_sso_id_hashed: sso1,
    userSsoIdHashed: sso2,
    user__open_id_identifier_hashed: sso3,
    open_id_identifier_hashed: sso4,
  }) {
    this.id = id || `${(counter += 1)}-${new Date().getTime()}`;
    this.screenName = screenName || "Anonymous";
    this.fullName = fullName || "Anonymous";
    this.profileUrl = `/profile/@${screenName}`;
    this.organisation = null;
    this.ssoId = sso1 || sso2 || sso3 || sso4;
  }

  stringify() {
    const name = this.fullName || this.screenName || "";
    const orgName = this.organisation && this.organisation.name;
    return orgName ? `${name} [${orgName}]` : name;
  }

  setOrganisation(orgInstance) {
    this.organisation = orgInstance;
    return this;
  }
}

export default User;
